export enum ValidationErrorMessageEnum {
    
    REQUIRED = "This field is required",
    MIN_LENGTH = "Must be at least 3 characters .",
    MIN_LENGTH_FIVE = "Use 5 characters or more for your password",
    MIN_LENGTH_TEN = "Must be 10 numbers .",
    MAX_LENGTH_TEN_NUMBERS = "Must be 10 numbers .",
    MAX_LENGTH = "Must not be more than 45 characters .",
    MIN_LENGTH_ONE = "Must be at least 1 characters .",
    MIN_LENGTH_THREE = "Must be at least 3 characters .",
    MAX_LENGTH_FIFTEEEN = "Must not be more than 15 characters .",
    MAX_LENGTH_FORTY_FIVE = "Must not be more than 45 characters .",
    MIN_LENGTH_TWO = "Must be at least 2 characters .",
    MAX_LENGTH_HUNDRED = "Must not be more than 100 characters .",
    MAX_LENGTH_TEN = "Must not be more than 10 characters .",
    MAX_LENGTH_ONE_FIFTY = "Must not be more than 150 characters .",
    MAX_LENGTH_TWO_HUNDRED = "Must not be more than 200 characters .",
    MAX_LENGTH_NINTYFIVE = "Must not be more than 95 characters .",
    MAX_LENGTH_THOUSAND = "Must not be more than 1000 characters .",
    MAX_LENGTH_SIXTY = "Must not be more than 60 characters .",
    MAX_LENGTH_FIVE_HUNDRED = "Must not be more than 500 characters .",
    MAX_LENGTH_TWO_HUNDRED_FIFTY = "Must not be more than 250 characters .",
    VALID_MOBILE = "Must be at valid Mobile Number .",
    ALPHABET="Only alphabets allowed",
    PATTERN="Password must contain characters and number",
    VALID_EMAIL="Invalid Email",
    TERMS_AND_COND="Please accept the terms and conditions",
    MAX_LENGTH_FIFTEEEN_NUMBER= "Must not be more than 15 number .",
    EMIAL_REQUIRED = "Enter your email id",
    PASWORD_REQUIRED = "Enter your password"
}